import { useTranslation } from "react-i18next";
import { RootState } from "../../store/store";
import { useSelector, useDispatch } from "react-redux";
import { useContext } from "react";
import { SocketContext } from "../../context/socket";
import { setCurrentPage } from "../../store/slices/PlayerSlice";
import propagandaPlayer from "../../assets/propaganda-player.svg";

export function Skip() {
  const { t } = useTranslation();
  const code = useSelector((state: RootState) => state.player.code);
  const socket = useContext(SocketContext);
  const dispatch = useDispatch();
  const playerImageAlt = "player image";

  const startGame = () => {
    socket.emit("SKIP", { roomId: code });
    dispatch(setCurrentPage("round"));
  };

  return (
    <div
      id="skip"
      className="player-game-min relative z-0 w-screen overflow-x-hidden overflow-y-auto bg-join-background bg-cover"
    >
      <div className="player-game-min pointer-events-none absolute inset-0 z-10 bg-orange opacity-40" />
      <div className="relative z-30 flex w-full flex-col items-center justify-start gap-6 px-4 py-6 player-game-safe-y">
        <img
          alt={playerImageAlt}
          className="z-30 mt-4 h-24 w-auto shrink object-contain phone:mt-2 desktop:mt-8 desktop:h-44"
          src={propagandaPlayer}
        />
        <button
          className="z-30 mt-2 h-28 w-28 shrink-0 rounded-full border-2 border-dark-blue bg-btn-red font-Cairo text-3xl text-darker-blue disabled:opacity-50 desktop:mt-8 desktop:h-56 desktop:w-56 desktop:text-5xl"
          onClick={startGame}
        >
          {t("join.skip")}
        </button>
      </div>
    </div>
  );
}
